export default (state, status) => {
  state.loggedin.status = status;
}


// WEBPACK FOOTER //
// ./src/app/store/users/mutations/set-logged-in-status.js